import { render } from "./SliderImage.vue?vue&type=template&id=bc28f22e&scoped=true"
import script from "./SliderImage.vue?vue&type=script&lang=js"
export * from "./SliderImage.vue?vue&type=script&lang=js"

import "./SliderImage.vue?vue&type=style&index=0&id=bc28f22e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc28f22e"]])

export default __exports__